import * as React from "react";
import { Box } from "@mui/material";
import { useMediaQuery } from "@mui/material";

export interface Props {
    children: JSX.Element | JSX.Element[];
    topComponent?: JSX.Element;
    bottomComponent?: JSX.Element;
    hasPx?: boolean;
}

export const MainLayout = ({
    children,
    topComponent,
    bottomComponent,
    hasPx,
}: Props) => {
    const isSmallScreen = useMediaQuery("(max-width: 640px)");

    return (
        <>
            {topComponent && (
                <Box
                    paddingBottom={2}
                    paddingX={2}
                    paddingTop={isSmallScreen ? 2 : 4}
                    textAlign="center"
                >
                    {topComponent}
                </Box>
            )}
            <Box
                py={2}
                px={hasPx ? 2 : undefined}
                textAlign="left"
                justifyContent="center"
                alignItems="center"
            >
                {children}
            </Box>
            {bottomComponent && (
                <Box paddingX={2} textAlign="center">
                    {bottomComponent}
                </Box>
            )}
        </>
    );
};

export const commonBoxStyle = {
    justifyContent: "center",
    display: "flex",
    gap: "16px",
};
